<script>
import { formatBytes } from 'shared/helpers/FileHelper';

export const FILE_ICONS = {
  pdf: 'document-pdf',
  docx: 'document-text',
  txt: 'document-text',
  md: 'document-text',
  csv: 'document-table',
};

export default {
  name: 'OnboardingStagedFileCard',
  props: {
    // A browser File, or any { name, size } object.
    file: {
      type: [File, Object],
      required: true,
    },
    highlighted: {
      type: Boolean,
      default: false,
    },
    // The processing modal reuses this card read-only, with a status badge
    // in the default slot instead of a remove button.
    removable: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['remove'],
  computed: {
    extension() {
      const parts = this.file.name.split('.');
      return parts.length > 1 ? parts.pop().toLowerCase() : '';
    },
    icon() {
      return FILE_ICONS[this.extension] || 'document';
    },
    meta() {
      // Documents restored after a refresh come from the server and carry no
      // byte size — show just the type rather than "NaN undefined".
      const size = this.file.size ? formatBytes(this.file.size, 1) : '';
      const type = this.extension ? this.extension.toUpperCase() : '';
      return [type, size].filter(Boolean).join(' · ');
    },
  },
};
</script>

<template>
  <div
    class="relative flex flex-col items-center gap-2 p-4 pt-6 text-center border rounded-lg bg-white dark:bg-slate-800 transition-shadow duration-700"
    :class="
      highlighted
        ? 'border-woot-500 ring-2 ring-woot-500/40'
        : 'border-slate-200 dark:border-slate-700'
    "
    data-testid="kb_staged_file_card"
  >
    <button
      v-if="removable"
      type="button"
      :aria-label="$t('ONBOARDING_SHELL.STEPS.KNOWLEDGE_BASE.REMOVE_FILE')"
      class="absolute top-1.5 right-1.5 p-1 rounded-full text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-700"
      data-testid="kb_remove_staged_file"
      @click="$emit('remove')"
    >
      <fluent-icon icon="dismiss" size="14" />
    </button>
    <fluent-icon :icon="icon" size="40" class="text-woot-500" />
    <span
      class="w-full text-sm font-medium text-slate-800 dark:text-slate-100 break-words line-clamp-2"
      :title="file.name"
    >
      {{ file.name }}
    </span>
    <span class="text-xs text-slate-500 dark:text-slate-400">{{ meta }}</span>
    <slot />
  </div>
</template>
